import seedrandom from 'seedrandom';

export function createRng(seed: string): () => number {
  const rng = seedrandom(seed);
  return () => rng.quick();
}

export function randomSeed(): string {
  return `random-${Date.now()}-${Math.floor(Math.random() * 1_000_000)}`;
}

export function dailySeed(date: Date = new Date()): string {
  const iso = date.toISOString().split('T')[0];
  return `daily-${iso}`;
}
